import React from 'react';
import { connect } from 'react-redux';
import { Motion, spring } from 'react-motion';
import Dot from './Dot'
import {
  positionX, positionY, angleNumber, numberOfNodes, parentNumber, angleValue
  } from '../../common/node'

const ChildDots = props => {
  const { id, client, server, parent, page, root } = props
  let children = numberOfNodes(page, server.children[id], root)
  let pAngle = angleValue(client.x[parent], client.y[parent], client.x[parentNumber(parent)], client.y[parentNumber(parent)])
  let angle = angleNumber(page, server.children[id], root)

  if (client.status[parent]==='closing') {
    return (
      <div />
    )
  }

  return(
    <div> {
      Array.apply(null, Array(children))
        .map(function () { return {x: client.x[parent], y: client.y[parent], n: parent} })
        .map(function(active, i) {
          return(
            <Motion style={{
              translateX: spring(active.x, { stiffness: 200, damping: 10 }),
              translateY: spring(active.y, { stiffness: 200, damping: 10 })}}>
              {({translateX, translateY}) =>
                  <div>
                  { (i === (children-1) && (page+children) < server.children[id].length )
                      ?(
                        <Dot
                          x={client.x[(active.n+'.'+(page+i))] ||
                            (positionX(240, pAngle + Math.PI/angle*(i+1))+translateX)}
                          y={client.y[(active.n+'.'+(page+i))] ||
                            (positionY(240, pAngle + Math.PI/angle*(i+1))+translateY)}
                          id={id}
                          px={active.x} py={active.y} page={page+children-1}
                          number={active.n+'.'+(page+i)} key={active.n+'.'+(page+i)} root={false}
                          />
                      )
                      :(
                        <Dot
                          x={client.x[(active.n+'.'+(page+i))] ||
                            (positionX(240, pAngle + Math.PI/angle*(i+1))+translateX)}
                          y={client.y[(active.n+'.'+(page+i))] ||
                            (positionY(240, pAngle + Math.PI/angle*(i+1))+translateY)}
                          id={server.children[id][i+page]}
                          px={active.x} py={active.y} page={0}
                          number={active.n+'.'+(page+i)} key={active.n+'.'+(page+i)} root={false}
                          />
                      )
                  }
                  </div>
              }
            </Motion>
          )
        })}
      </div>
  )

}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server,
});

export default connect(mapStateToProps)(ChildDots);



// WEBPACK FOOTER //
// ./src/components/dots/ChildDots.js